// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // host: 'http://localhost:65528/api/web',
    host: 'https://dev.finamsa.com.py:60101/api/web',
    // host: 'http://192.168.0.78:65528/api/web',
    JWT_API:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIyMDIzMDYxNyIsIm5hbWUiOiJ3YWt0dSBlcnAiLCJpYXQiOjE1MTYyMzkwMjJ9.98bsMf9n6vd-NxGmqnh4MQheK84lD8BKVW_uLRPDCJ4',
    SECRET_KEY: 'm1cr0.2024',
    VERSION: '2.3.6',
    FECHA: '30/01/2026',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
